// font family list
const fontFamily = {
  circularTt: '"Circular TT", Arial',
  centraNo2: 'CentraNo2-Medium, fallback-font, sans-serif',
  skolarSans: 'SkolarSans, sans-serif',
  kaufland: 'Kaufland, sans-serif',
};

export default fontFamily;

// font family for themes
export const getoloFontFamily = fontFamily.circularTt;
export const daDirektFontFamily = fontFamily.centraNo2;
export const daKauflandFontFamily = fontFamily.kaufland;
export const fressnapfFontFamily = fontFamily.skolarSans;
